// extracted by mini-css-extract-plugin
export default {"improvedUpgrades":"improved-eco-upgrades_improvedUpgrades__xGP4y"};